import type { ISystemInfo, TRestriction } from '../definitions'

import isOsRestricted      from './isOsRestricted'
import isBrowserRestricted from './isBrowserRestricted'

/**
 * Az adott adatok alapján kell-e korlátozni.
 * @param restriction - Korlátozás adatai.
 * @param info        - Os és böngész info.
 */
export default function isRestrictedByRestriction (restriction: TRestriction, info: ISystemInfo): boolean {
  let isRestrictedOs = false
  let isRestrictedBrowser = false

  const isOsRestrictionDefined = 'os' in restriction

  if (isOsRestrictionDefined) {
    isRestrictedOs = isOsRestricted(
      restriction.os,
      info.os.name,
      info.os.version
    )
  }

  const isBrowserRestrictionDefined = 'browser' in restriction

  if (isBrowserRestrictionDefined) {
    isRestrictedBrowser = isBrowserRestricted(
      restriction.browser,
      info.browser.name,
      info.browser.version
    )
  }

  const isCombinedRestriction = isOsRestrictionDefined && isBrowserRestrictionDefined

  const isRestricted = isCombinedRestriction
    // Ha az Os és Browserre is írtunk feltételt, akkor mindkettőnek teljesülni kell
    ? isRestrictedBrowser && isRestrictedOs
    // egyébként meg, elég az egyiknek.
    : isRestrictedBrowser || isRestrictedOs

  return isRestricted
}
